"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[46794],{

/***/ 619947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ActionButtons": function() { return /* binding */ ActionButtons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(916476);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(314408);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(891256);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(309110);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47649);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54230);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(141873);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(446586);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(428247);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(534090);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











const ActionButtons = ()=>{
    var ref;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { product , primitiveProduct , isOutOfStock , isCanAddToCard , stockAvailable , price , payloadAddToCart , selectedPromotion , actionReady , isAllowInstallmentPayment , selectedPromotionsNotApplyWithInstallment , showWarningPromotionWithInstallment , setShowWarningPromotionWithInstallment , minAmountByMonth ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useProductDetailState */ .W)();
    const { contactLink , allowBuyNow , epicOmni1459  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useTenantConfig */ .Wx)();
    const showToast = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .useToast */ .p)();
    const { onAddSingleItem  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useCartV2 */ .T6)();
    const isValidPrice = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        if (!product) return false;
        if (price) return (price === null || price === void 0 ? void 0 : price.finalPrice) && (price === null || price === void 0 ? void 0 : price.finalPrice) >= 0;
    }, [
        product,
        price
    ]);
    const showContact = !isValidPrice || isOutOfStock || !(product === null || product === void 0 ? void 0 : (ref = product.status) === null || ref === void 0 ? void 0 : ref.sellable);
    const trackingPayload = JSON.stringify({
        sku: product === null || product === void 0 ? void 0 : product.sellerSku,
        screenName: "productDetail"
    });
    const onAddItemToCart = async (type)=>{
        var ref, ref1;
        if (!isCanAddToCard) {
            var ref2;
            (ref2 = showToast.info) === null || ref2 === void 0 ? void 0 : ref2.call(showToast, {
                title: "",
                message: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Chỉ c\xf2n {{stockAvailable}} sản phẩm", {
                    stockAvailable: stockAvailable
                }),
                type: "error",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__/* .CautionOutlined */ .s, {
                    size: 50,
                    color: "#E24C4B"
                })
            });
            return;
        }
        if (!primitiveProduct) return;
        // params send to Teko tracking in event addToCart
        const trackAddToCartParams = {
            product: {
                sku: (product === null || product === void 0 ? void 0 : product.sellerSku) || "",
                name: (product === null || product === void 0 ? void 0 : product.name) || "",
                brand: product === null || product === void 0 ? void 0 : product.brand,
                categories: product === null || product === void 0 ? void 0 : product.categories,
                price: parseFloat((product === null || product === void 0 ? void 0 : (ref = product.price) === null || ref === void 0 ? void 0 : (ref1 = ref.supplierRetailPrice) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "0"),
                addToCartPrice: (price === null || price === void 0 ? void 0 : price.finalPrice) || 0,
                sellerSku: product === null || product === void 0 ? void 0 : product.sellerSku
            },
            selectedPromotionId: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId,
            type
        };
        try {
            if (!(payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku)) return;
            const res = await onAddSingleItem({
                sku: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku,
                promotionId: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId,
                quantity: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity,
                isPrimary: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.isPrimary
            }, false, allowBuyNow && type === _teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.BUYNOW */ .h.BUYNOW ? _teko_cart_v2__WEBPACK_IMPORTED_MODULE_11__/* .IsolatedCartType.BUY_NOW */ .oG.BUY_NOW : epicOmni1459 && type === _teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.INSTALLMENT */ .h.INSTALLMENT ? _teko_cart_v2__WEBPACK_IMPORTED_MODULE_11__/* .IsolatedCartType.INSTALLMENT */ .oG.INSTALLMENT : undefined);
            if (res) {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_12__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "success",
                    cartId: res.id
                }));
            } else {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_12__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "failed"
                }));
            }
            if (res && (type === _teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.BUYNOW */ .h.BUYNOW || type === _teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.INSTALLMENT */ .h.INSTALLMENT)) {
                if (type === _teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.BUYNOW */ .h.BUYNOW && !allowBuyNow) {
                    router.push("/cart");
                } else {
                    const key = (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_11__/* .getBuyNowKey */ .B2)(true);
                    router.push("/checkout?bnk=".concat(key));
                }
            }
        } catch (e) {
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_12__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                status: "failed"
            }));
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(e);
        }
    };
    const handlePayOnInstallment = ()=>{
        if (selectedPromotionsNotApplyWithInstallment.length > 0) {
            return setShowWarningPromotionWithInstallment(true);
        }
        return onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.INSTALLMENT */ .h.INSTALLMENT);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !showContact && (isAllowInstallmentPayment ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                            variant: "primary",
                            block: true,
                            marginTop: "s16",
                            onClick: ()=>onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.BUYNOW */ .h.BUYNOW),
                            disabled: !actionReady,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                                level: 2,
                                weight: "medium",
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Mua ngay").toUpperCase()
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddToCartButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .getTrackingData */ .O5)({
                                isTrackContent: true,
                                contentName: "addToCart",
                                target: "productDetail",
                                regionName: "descriptionDetail",
                                payload: trackingPayload
                            })), {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                    variant: "secondary",
                                    onClick: ()=>onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART),
                                    block: true,
                                    disabled: !actionReady,
                                    height: "57px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                                        level: 2,
                                        weight: "medium",
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("TH\xcaM V\xc0O GIỎ H\xc0NG")
                                    })
                                })
                            })),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuyNowButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .getTrackingData */ .O5)({
                                isTrackContent: true,
                                contentName: "buyNow",
                                regionName: "descriptionDetail",
                                target: "cart",
                                payload: trackingPayload
                            })), {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                    variant: "primary",
                                    onClick: handlePayOnInstallment,
                                    className: "att-detail-page-buy-now-button",
                                    block: true,
                                    disabled: !actionReady,
                                    backgroundColor: "#F89E33",
                                    height: "57px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonText, {
                                        level: 2,
                                        weight: "medium",
                                        children: [
                                            (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Mua trả g\xf3p").toUpperCase(),
                                            typeof minAmountByMonth === "number" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Chỉ từ"), " ").concat((0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_14__/* .formatCurrency */ .xG)(minAmountByMonth), "/").concat((0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("th\xe1ng"))
                                            })
                                        ]
                                    })
                                })
                            }))
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuyNowButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .getTrackingData */ .O5)({
                        isTrackContent: true,
                        contentName: "buyNow",
                        regionName: "descriptionDetail",
                        target: "cart",
                        payload: trackingPayload
                    })), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                            variant: "primary",
                            onClick: ()=>onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.BUYNOW */ .h.BUYNOW),
                            className: "att-detail-page-buy-now-button",
                            block: true,
                            disabled: !actionReady,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                                level: 2,
                                weight: "medium",
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Mua ngay").toUpperCase()
                            })
                        })
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddToCartButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .getTrackingData */ .O5)({
                        isTrackContent: true,
                        contentName: "addToCart",
                        target: "productDetail",
                        regionName: "descriptionDetail",
                        payload: trackingPayload
                    })), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                            variant: "secondary",
                            onClick: ()=>onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART),
                            block: true,
                            disabled: !actionReady,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                                level: 2,
                                weight: "medium",
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("TH\xcaM V\xc0O GIỎ H\xc0NG")
                            })
                        })
                    }))
                ]
            })),
            showContact && !!contactLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__/* .CustomLink */ .x, {
                href: contactLink,
                target: "_blank",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactSaleButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .getTrackingData */ .O5)({
                    isTrackContent: true,
                    regionName: "descriptionDetail",
                    contentName: "contactSale",
                    target: "productDetail",
                    payload: trackingPayload
                })), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                        variant: "primary",
                        block: true,
                        marginTop: "s16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                            level: 2,
                            weight: "medium",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("LI\xcaN HỆ")
                        })
                    })
                }))
            }),
            showContact && !contactLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                disabled: true,
                block: true,
                marginTop: "s16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                    level: 2,
                    weight: "medium",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("HẾT H\xc0NG")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__/* .Modal */ .u, {
                visible: showWarningPromotionWithInstallment,
                size: "s",
                cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Quay lại"),
                onCancel: ()=>setShowWarningPromotionWithInstallment(false),
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Tiến h\xe0nh trả g\xf3p"),
                onOk: ()=>{
                    setShowWarningPromotionWithInstallment(false);
                    onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.INSTALLMENT */ .h.INSTALLMENT);
                },
                showCloseIcon: false,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__/* .ModalHeader */ .x, {
                        padding: "s0",
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Th\xf4ng b\xe1o")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_18__/* .ModalBody */ .f, {
                        paddingLeft: "s0",
                        paddingRight: "s0",
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Sản phẩm c\xf3 khuyến mại kh\xf4ng được \xe1p dụng khi mua trả g\xf3p. Vui l\xf2ng chọn lại khuyến mại kh\xe1c hoặc tiến h\xe0nh trả g\xf3p m\xe0 kh\xf4ng \xe1p dụng khuyến mại")
                    })
                ]
            })
        ]
    });
};
const ButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__["default"].div(_templateObject());
const ButtonText = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__/* .SubTitle */ .DK)(_templateObject1());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__/* .Button */ .z)((param)=>{
    let { height  } = param;
    return "\n  height: ".concat(height || "46px", ";\n");
});
const BuyNowButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__["default"].div(_templateObject2());
const AddToCartButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__["default"].div(_templateObject3());
const ContactSaleButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__["default"].div(_templateObject4());


/***/ })

}]);